import React from 'react';

import { WebsiteLink } from 'web-ui-components/lib/actions/links';
import { StandardBody } from 'web-ui-components/lib/typography/body';

export const WarningDescription = ({ data }) => {
	const description = data.split(/\[(.*?)\]/).map((stringMatch, index) => {
		const [linkText, linkURL] = stringMatch.split('=');
		return !linkURL ? (
			linkText
		) : (
			<WebsiteLink key={`link_${index}`} linkText={linkText} url={linkURL} willOpenNewWindow />
		);
	});

	return <StandardBody>{description}</StandardBody>;
};
